import { FormActions } from "../../components/common/FormActions";
import {
  BooleanTags,
  PaymentStatusTag,
} from "../../components/common/registerUtils";
import {
  createColumn,
  createViewAction,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { URL_PARKED_CARS_SERVICES } from "../../utils/urls";

const useParkedCarsService = () => {
  const tableColumns = () => [
    createColumn("service_name", true, "Service Name"),
    createColumn("vehicle_type_name", true, "Vehicle Type"),
    createColumn("car_number", true, "Number Plate"),
    createColumn("phone_number", true, "Phone Number"),
    createColumn("amount_paid", true, "Amount Paid"),
    createColumn("payment_status", true, "Payment Status"),
    createColumn("is_parking_ended", true, "Parking Ended"),
    createColumn("start_time", { type: "date", range: true }),
    createColumn("end_time", { type: "date", range: true }),
    createColumn("actions", false, "Actions"),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data.map((item: any) => {
      return {
        ...item,
        start_time: formatDateTime(item.start_time),
        end_time: formatDateTime(item.end_time),
        amount_paid: numberFormat(item?.amount_paid),
        payment_status: <PaymentStatusTag status={item?.payment_status} />,
        declaration: <BooleanTags status={item.declaration} />,
        is_parking_ended: <BooleanTags status={item.is_parking_ended} />,
        actions: (
          <FormActions
            actions={[createViewAction(URL_PARKED_CARS_SERVICES, item?.id)]}
          />
        ),
      };
    });
  };

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }
    return {
      sections: [
        {
          title: "Vehicle Information",
          fields: {
            service_name: item?.service_name || "N/A",
            vehicle_type_name: item?.vehicle_type_name || "N/A",
            declaration: item?.declaration ? "Accepted" : "Not accepted",
            car_number: item?.car_number || "N/A",
            phone_number: item?.phone_number || "N/A",
            email: item?.email || "Not provided",
            car_size: item?.car_size_name || "Not specified",
          },
        },
        {
          title: "Parking Details",
          fields: {
            slot_name: item?.slot_name,
            declaration: <BooleanTags status={item.declaration} />,
          },
        },
        {
          title: "Time Information",
          fields: {
            start_time: item?.start_time
              ? formatDateTime(item.start_time)
              : "N/A",
            end_time: item?.end_time ? formatDateTime(item.end_time) : "Active",
            is_parking_ended: <BooleanTags status={item.is_parking_ended} />,
          },
        },
        {
          title: "Location Coordinates",
          fields: {
            latitude: item?.latitude || "0",
            longitude: item?.longitude || "0",
          },
        },
      ],
    };
  };

  return {
    tableColumns,
    tableData,
    viewData,
  };
};

export default useParkedCarsService;
